import type { ContextManager, IWixMediaCanvas } from '@wix/canvas'

const MAX_CONTEXTS = 8

const contextManager: ContextManager = {
	set: new Set<IWixMediaCanvas>(),
	add(key: IWixMediaCanvas) {
		if (contextManager.set.has(key)) {
			return true
		}

		if (contextManager.set.size < MAX_CONTEXTS) {
			contextManager.set.add(key)
			return true
		}

		return false
	},
	remove(key: IWixMediaCanvas) {
		contextManager.set.delete(key)
	},
	get count() {
		return contextManager.set.size
	},
}

export default contextManager
